import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Avatars from "../Avatar/Avatar";
import Divider from "@mui/material/Divider";
//----------------------------------------------------------------
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Loading from "../Loading/CircularDeterminate";
import { useAuth } from "../Auth/AuthProtecter";


export default function AvatarView({ name, ...pros }) {
  const auth = useAuth();
  const { person, email } = auth.infoUserDasboard;

  const [data, setArrayUser] = React.useState(false);

  useEffect(() => {
    //
    setArrayUser(person)
    //
  });

// lastname
  return data ? (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Typography variant="h6" gutterBottom>
        Avatar
      </Typography>
      <Box
        sx={{
          // marginTop: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatars />
        <Divider />
        <Typography component="h1" variant="h6">
          <TextField label="Usuario" value={`${person.firstname} ${person.lastname}`} variant="standard" />
        </Typography>
        <Typography component="h1" variant="h6">
          <TextField
            label="Correo"
            value={email.email}
            fullWidth
            variant="standard"
          />
        </Typography>
      </Box>
    </Container>
  ) : (
    <>
      <Loading />
    </>
  );
}
